import classNames from 'classnames';
import { forwardRef } from 'react';
import { useIsWideMainLayout, useIsZeroPaddingMainLayout } from './hooks';
const containerIsWideCss = "ckp8fa6";
const containerCss = "citxq8s";
const Container = forwardRef((props, ref) => {
  const {
    isWide,
    zeroPadding,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsWideCss]: isWide,
    zeroPadding
  }, props.className)} />;
});
export const MainRegion = ({
  children
}) => {
  const [isWide] = useIsWideMainLayout();
  const [zeroPadding] = useIsZeroPaddingMainLayout();
  return <Container isWide={isWide} zeroPadding={zeroPadding}>
      {children}
    </Container>;
};

require("./region.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./region.js");